export type TProductKey =
  | 'personal_cards'
  | 'shared_cards'
  | 'day_cards'
  | 'e_tickets'
  | 'printed_tickets'
  | 'saldo_laden'

/** The contract keys that surface the E-tickets page (wallet + homeprint Tranzer tickets). */
export const E_TICKET_PRODUCT_KEYS = ['e_tickets', 'printed_tickets'] as const satisfies readonly TProductKey[]
